import { useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css";
//image
import toast, { Toaster } from 'react-hot-toast';

import { useNavigate } from 'react-router-dom';
import PostCardBody from './GroupCardBody';
import InfiniteScroll from 'react-infinite-scroll-component';

import GroupCardBody from './GroupCardBody';
import { getToken } from '../../../../utils/auth';
import Card from '../../../../components/Card';
import { useTranslation } from 'react-i18next';


const GroupCard = ({ post, handleAllPost }) => {
    const navigate = useNavigate();
    const location = useLocation();
      const { t, i18n } = useTranslation();
    
    useEffect(() => {
        if (!getToken()) {
            navigate("/auth/sign-in")
        }
    }, []);

    return (
        <>
<Toaster position="top-right" reverseOrder={false}/>
<Col lg="12">

                {post && post.length > 0 ? (
                    post.map((data, index) => (
                        <Card>
                            <GroupCardBody data={data} index={index} handleAllPost={handleAllPost}/>
                        </Card>
                    ))
                ) : (
                    <p style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>{t("noPostYet")}.</p>
                )}
            </Col>
        </>
    )
}

export default GroupCard
